import { useStaticQuery, graphql } from 'gatsby'

import EventForm from '~components/EventForm'

const WeeklyLiveDemoForm = (props) => {
  const {
    file: {
      childMdx: { frontmatter: pageData },
    },
  } = useStaticQuery(graphql`
    query WeeklyLiveDemoFormData {
      file(
        name: { eq: "weekly-live-demo" }
        absolutePath: { regex: "/src/data/" }
      ) {
        childMdx {
          frontmatter {
            hero {
              form {
                bigMarkerSession
                programId
                heading
              }
            }
            eventSessions {
              date
              time
              id
            }
          }
        }
      }
    }
  `)

  return (
    <EventForm
      fieldValues={{
        programID: pageData.hero.form?.programId,
        bigMarkerSession: pageData.hero.form?.bigMarkerSession,
      }}
      sessions={pageData.eventSessions}
      title={pageData.hero.form?.heading}
      variation="weekly-live-demo"
      {...props}
    />
  )
}

export default WeeklyLiveDemoForm
